export const en = {
    title: 'The business trip is over',
    description: 'If everything went well or if there were any difficulties, let us know',
    send_feedback: 'Leave feedback',
};
